module.exports = __webpack_public_path__ + "static/img/6.0fc752e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/6.png
// module id = rk1N
// module chunks = 0